const init = () => {
  const message = require('./message');
  const ajaxSync = require('./ajaxSync');
  $.extend({message, ajaxSync});
};
module.exports = {init};